import { createContext, useContext, useState, useEffect } from "react";

export const SiteThemeContext = createContext({ siteTheme: "dark", toggleSiteTheme: () => {} });

export function useSiteTheme() {
  return useContext(SiteThemeContext);
}

export function SiteThemeProvider({ children }) {
  const [siteTheme, setSiteTheme] = useState(() => {
    try { return localStorage.getItem("yen_site_theme") || "dark"; } catch { return "dark"; }
  });

  function toggleSiteTheme() {
    setSiteTheme(prev => {
      const next = prev === "dark" ? "light" : "dark";
      try { localStorage.setItem("yen_site_theme", next); } catch {}
      return next;
    });
  }

  // Apply to document.body with transition
  useEffect(() => {
    document.body.style.transition = "background-color 0.35s ease, color 0.35s ease";
    if (siteTheme === "light") {
      document.body.style.backgroundColor = "#ffffff";
      document.body.style.color = "#0a0a0a";
      document.body.classList.add("site-light");
      document.body.classList.remove("site-dark");
    } else {
      document.body.style.backgroundColor = "#000";
      document.body.style.color = "#f0ede8";
      document.body.classList.add("site-dark");
      document.body.classList.remove("site-light");
    }
  }, [siteTheme]);

  return (
    <SiteThemeContext.Provider value={{ siteTheme, toggleSiteTheme }}>
      {children}
    </SiteThemeContext.Provider>
  );
}
